export default __webpack_public_path__ + "static/media/wyomingRealtors.ffc71ae4.png";